<template>
    <div class="js-header">
        <header class="front-bg-color white-color">
            <div class="f-left system-name" style="color:#67C23A">
                <b>平台</b> 系统管理
            </div>
            <div class="f-right apply_count">
                <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                        <a class="user white-color" style="margin:0 auto" href="javascript:;">
                           <!-- <img src="@/assets/image/default.jpg" alt /> -->
                            {{userInfo.username}}
                        </a>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item >
                            <a class="logout" @click="outLogin" href="javascript:;">
                                <i class="el-icon-circle-close"></i>
                                <span class="icon fa fa-power-off" style="font-size:20px;"></span>
                                退出
                            </a>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </header>
        <div style="position: relative;"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            userInfo: {},
        };
    },
    created() {
        var _this = this;
        _this.userInfo = _this.$common.user_info();
        _this.validToken();
    },
    methods: {
        validToken () {
            var _this = this;
            _this.$common.my_ajax({
                url: '/user/validToken',
                success: function(response) {
                    if (!response.item) {
                        _this.outLogin();
                    }
                }
            });
        },
        outLogin() {
            let _this = this;
            _this.$common.cache();
            _this.$router.push({ name: "login" });
        },
        handleCommand() {
            
        }
    }
};
</script>
<style scoped>
.apply_count {
    color: ;
}

a:hover,
a:active {
    color: #67c23a;
}
</style>